<template>
  <div class="w-full mx-auto xl:max-w-screen-xl">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean
    }
  }
}
</script>
